<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="comment" rules="" v-slot="{valid, errors}">
                        <b-form-group>
                            <b-form-textarea
                                v-model="form.comment"
                                id="textarea-rows"
                                placeholder="Comments"
                                rows="8"
                            ></b-form-textarea>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <b-col cols="12" class="pl-0">
            <b-button
                @click="update"
                type="button"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("update") | toUpperCase }}
            </b-button>
        </b-col>
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate"
import AssessmentBulkEntryServices from "@/services/AssessmentBulkEntryServices";
import StudentSessionService from "@/services/StudentSessionService";

export default {
    props:{
      formId:{
          type:Number,
          required:true
      },
      comment:{
         type:String,
          validator(value){
             return value===null ||typeof value ==="string"
          }
      }
    },
    components: {
        ValidationProvider, ValidationObserver
    },
    data() {
        return {
            formLoading: false,
            form: {
                comment: null,
            }
        }
    },
    created() {
   /*   this.form.comment=this.comment*/

      this.getComments()
    },
    methods: {
        async getComments(){
            StudentSessionService.show(this.formId).then((response)=>{
               this.form.comment = response.data.data.comment;
            }).catch(err=>{
                this.showErrors(err)
            })
        },
        async update() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    AssessmentBulkEntryServices.updateComment(this.formId,this.form)
                        .then((response) => {
                            this.$toast.success(this.$t("Comment Updated"));
                            this.$emit("updateComment")
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate)
                        });
                }
        }
    }
}
</script>
